import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setAssignee } from 'bundles/apex/deals/show/store/planner_bulk_actions/actions';

import { Alert } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import Options from 'components/form/managed_input/options';
import pluralize from 'pluralize';

export function ReassignModal({ assignee, selection, show, userOptions, onClose, setAssignee, onUpdate }) {
  const [errors, setErrors] = useState([]);
  const selectionCount = Object.keys(selection).length;
  const updateTasks = async () => {
    const message = 
      `${selectionCount} ${pluralize('tasks', selectionCount)} ${pluralize('has', selectionCount)}` +
      ` been reassigned to ${userOptions.find(user => user.value == assignee).label}`;

    const response = await onUpdate({ assignee_id: assignee }, message);
    if (response.errors) {
      setErrors(response.errors);
    } else {
      onClose();
    }
  };

  const resetModal = () => {
    setErrors([]);
    setAssignee(null);
  };

  const alertTitle = `Could not reassign assignee for ${pluralize('tasks', selectionCount)}`;
  
  return (
    <Modal
      show={show}
      onHide={onClose}
      onShow={resetModal}
    >
      <Modal.Header closeButton>Reassign Tasks</Modal.Header>

      <Modal.Body className="form-vertical-field-container">
        {errors.length > 0 &&
          <Alert className="mb-4" variant="warning">
            <h6><strong>Whoops -</strong> {alertTitle}</h6>
            <ul>
              {errors.map((error, i) => <li key={i}>{error}</li>)}
            </ul>
          </Alert>
        }
        <ManagedFormGroup
          includeBlank
          label="Assignee"
          name="assignee"
          type="select"
          value={assignee}
          onValueChange={setAssignee}
        >
          <Options options={userOptions}/>
        </ManagedFormGroup>
        <p>
          Are you sure you want to reassign <strong>{selectionCount}</strong> {pluralize('tasks', selectionCount)}?
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onClose} />
        <Button disabled={!assignee} label="Yes, Update" onClick={updateTasks} />
      </Modal.Footer>
    </Modal>
  );
}

ReassignModal.propTypes = {
  assignee: PropTypes.string,
  selection: PropTypes.object.isRequired,
  setAssignee: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  userOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  assignee: state.plannerBulkActions.assignee,
  selection: state.plannerBulkActions.selection,
  userOptions: state.options.users,
});

const mapDispatchToProps = {
  setAssignee
};

export default connect(mapStateToProps, mapDispatchToProps)(ReassignModal);
